import React, { useContext } from 'react';
import Brand from 'layout/Brand/Brand';
import Navigation, { NavigationLine } from 'layout/Navigation/Navigation';
import User from 'layout/User/User';
import ThemeContext from 'contexts/themeContext';
import Aside, { AsideBody, AsideFoot, AsideHead } from 'layout/Aside/Aside';
import { dashboardMenu, loansMenu } from 'menu';

const DefaultAside = () => {
	const { asideStatus, setAsideStatus } = useContext(ThemeContext);

	return (
		<Aside>
			<AsideHead>
				<Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
			</AsideHead>
			<AsideBody>
				<Navigation menu={dashboardMenu} id='aside-dashboard' />
				<NavigationLine />
				<Navigation menu={loansMenu} id='aside-loans' />
			</AsideBody>
			<AsideFoot>
				<User />
			</AsideFoot>
		</Aside>
	);
};

export default DefaultAside;
